<template>
  <v-card-title
    v-if="showSearchBar">
    <v-layout justify-end>
      <v-flex xs4>
        <v-text-field
          v-model="searchPhrase"
          class="subheading font-weight-light krita-dark text--darken-3"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          clearable
          @click:append="search"
          @change="search"
          @click:clear="clearSearch"
          @keydown.esc="clearSearch"
        />
      </v-flex>
    </v-layout>
  </v-card-title>
</template>

<script>
  import Debounce from '../helper/Debounce'
    export default {
        name: "SearchTextField",
        props: ['rowCount'],
        data() {
            return {
                searchPhrase: ''
            }
        },
      computed:
      {
        showSearchBar ()
        {
          let self = this;

          return self.rowCount >=10;
        }
      },
        methods: {
            clearSearch ()
            {
              let self = this;

              self.searchPhrase = '';
              self.search();
            },
            search ()
            {
              let self = this;

              if(self.searchPhrase === null)
              {
                self.searchPhrase = '';
              }

              self.$emit('search',self.searchPhrase)
            }
        }
    }
</script>

<style scoped>

</style>